var layout_default = {
  "layout": "r-f2-",
  "cell": "_6Y0H1"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
